import { TFunction } from "i18next";

import OneTwoThreeIcon from "../../../../../images/Illustration_Graph_Graduation_200x200-Color.png";
import PuzzlePieceIcon from "../../../../../images/Illustration_Puzzle_200x200-Color.png";
import FriendsIcon from "../../../../../images/Illustration_Shapes_200x200-Color.png";
import SubjectsIcon from "../../../../../images/Illustration_Subjects_200x200-Color.png";
import OneOnOneTutoringPng from "../../../../../images/school-page/1-on-1-tutoring.png";
import AfterschoolActivitiesPng from "../../../../../images/school-page/afterschool-activities.png";
import FullAcademicCoursesPng from "../../../../../images/school-page/full-academic-courses.png";
import NeurodiversePng from "../../../../../images/school-page/neurodiverse.png";

const getHumanReadableGradeLevel = (gradeLevel?: string) => {
  if (!gradeLevel) {
    return null;
  }
  const gradeLevelMap: { [key: string]: string } = {
    PK: "Pre-K",
    KG: "Kindergarten",
    "01": "1st",
    "02": "2nd",
    "03": "3rd"
  };

  if (gradeLevelMap[gradeLevel]) {
    return gradeLevelMap[gradeLevel];
  }
  const gradeNumber = parseInt(gradeLevel);
  return `${gradeNumber}th`;
};

export const getFormattedGradesString = (
  tStub: TFunction,
  startGrade?: string | null,
  endGrade?: string | null
) => {
  if (!startGrade || !endGrade) {
    return "";
  }
  const nonNumberedGrades = ["PK", "KG"];
  const startGradeIsNonNumbered = nonNumberedGrades.includes(startGrade);
  const endGradeIsNonNumbered = nonNumberedGrades.includes(endGrade);

  let formattedStartGrade = getHumanReadableGradeLevel(startGrade);
  if (!startGradeIsNonNumbered && !endGradeIsNonNumbered) {
    formattedStartGrade = `grades ${formattedStartGrade}`;
  }

  let formattedEndGrade = getHumanReadableGradeLevel(endGrade);
  if (startGradeIsNonNumbered && !endGradeIsNonNumbered) {
    formattedEndGrade = `Grade ${parseInt(endGrade)}`;
  }

  return tStub("Serving {{formattedStartGrade}} - {{formattedEndGrade}}", {
    formattedStartGrade,
    formattedEndGrade
  });
};

export const getTranslatedGradeCards = (tStub: TFunction) => [
  {
    text: tStub("1-on-1 tutoring"),
    imgUrl: OneOnOneTutoringPng,
    link: "/online-classes/tutoring"
  },
  {
    text: tStub("Full academic courses"),
    imgUrl: FullAcademicCoursesPng,
    link: "/online-classes/courses"
  },
  {
    text: tStub("Afterschool activities"),
    imgUrl: AfterschoolActivitiesPng,
    link: "/online-classes/afterschool"
  },
  {
    text: tStub("Neurodiverse"),
    imgUrl: NeurodiversePng,
    link: "/online-classes/neurodiverse"
  }
];

export const getTranslatedValuePropCards = (tStub: TFunction) => [
  {
    text: tStub("Improve grades and get ahead"),
    imgUrl: OneTwoThreeIcon
  },
  {
    text: tStub("Meet the unique needs of your learner"),
    imgUrl: PuzzlePieceIcon
  },
  {
    text: tStub("Personalized time with teachers"),
    imgUrl: SubjectsIcon
  },
  {
    text: tStub("Make new friends and build confidence!"),
    imgUrl: FriendsIcon
  }
];

export const getTranslatedPills = (tStub: TFunction) => [
  {
    name: tStub("English tutoring"),
    path: "/online-classes/english-tutoring"
  },
  {
    name: tStub("Math tutoring"),
    path: "/online-classes/math-tutoring"
  },
  {
    name: tStub("Music Lessons"),
    path: "/online-classes/music-private-lessons"
  },
  {
    name: tStub("Language Tutors"),
    path: "/online-classes/languages-tutoring"
  },
  {
    name: tStub("Elementary school tutoring"),
    path: "/online-classes/elementary-school-tutoring"
  },
  {
    name: tStub("Middle School Tutors"),
    path: "/online-classes/middle-school-tutoring"
  },
  {
    name: tStub("High School Tutors"),
    path: "/online-classes/high-school-tutoring"
  }
];
